import { createContext, useContext } from "react"

import { ProjectModel } from "features/project-management/types/ProjectModel"

export interface ProjectCardContextValue {
  model: ProjectModel | null
  isLoading: boolean
}

const ProjectCardContext = createContext<ProjectCardContextValue | undefined>(
  undefined
)

export { ProjectCardContext }

export function useProjectCardContext(): ProjectCardContextValue {
  const context = useContext(ProjectCardContext)
  if (!context) {
    throw new Error("useProjectCardContext must be used within a ProjectCard")
  }
  return context
}
